import { z } from "zod";

export const schema = z.object({
    guiche: z.string().min(1, "Guichê é obrigatório"),
    servico: z.string().min(1, "Serviço é obrigatório")
});